/* form
========================================================= */
export function form($) {
  updateSelectPlaceholders($);
  updateCheckedLabels($);
  controlSubmitButtons($);
}

function updateSelectPlaceholders($) {
  $('#mw_wp_form_mw-wp-form-5 .session select option[value=""]').text('選択してください');

  $('#mw_wp_form_mw-wp-form-19 .yakusyoku select option[value=""]').text('選択してください');
}

function updateCheckedLabels($) {
  $('.check_wrap').each(function () {
    const $wrapper = $(this);

    function update() {
      $wrapper.find('label').removeClass('input_checked');
      $wrapper.find(':checked').closest('label').addClass('input_checked');
    }

    $wrapper.find('input').on('change.formLabel', update);

    update();
  });
}

function controlSubmitButtons($) {
  $('.check_box').each(function () {
    const $checkbox = $(this);
    const $form = $checkbox.closest('form');

    const $applicationButton = $form.find('.input_box');
    const $contactButton = $form.find('.contact_box');

    function update() {
      const isChecked = $checkbox.prop('checked');

      $applicationButton.prop('disabled', !isChecked);
      $contactButton.prop('disabled', !isChecked);

      if (!isChecked) {
        $applicationButton.val('上記の内容で申し込む');
        $contactButton.val('上記の内容で送信する');
      }
    }

    $checkbox.on('change.formSubmit', update);

    update();
  });
}
